import authentication from "@irati/auth";
import { isPaymentRequired } from "./redemption/deal";
export default (function (deal, wallet) { return authentication.apps("wallet.users") && isPaymentRequired(deal) && wallet.availableBalance > 0; });
